<template>
  <div class="mb-2 col-2 px-1">
    <v-dialog v-model="dialog" max-width="290">
      <v-card>
        <v-card-title class="text-h6 text-center">
          {{ dialog_message }}
        </v-card-title>

        <v-card-actions>
          <v-spacer />

          <v-btn
            color="green darken-1"
            text
            @click="(dialog = false), (deldigit = false)"
          >
            ยกเลิก
          </v-btn>

          <v-btn
            color="red darken-1"
            text
            @click="(dialog = false), specialButtonDel()"
          >
            ยืนยัน
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <button
      :class="[classButton, { active: checkActive(keyValue, digitType) }]"
      @click="pushDigit"
    >
      <v-icon
        v-if="classButton == 'btn text-monospace w-100 btn-danger'"
        color="white"
        small
        left
      >
        mdi-star
      </v-icon>

      {{ convertString(keyValue, digitType) }}

      <v-icon
        v-if="classButton == 'btn text-monospace w-100 btn-danger'"
        color="white"
        small
        right
      >
        mdi-star
      </v-icon>
    </button>
  </div>
</template>

<script>
export default {
  name: "ButtonItem",
  props: {
    classButton: {
      type: String,
      default: "btn w-100 text-monospace btn-outline-dark",
    },
    keyValue: {
      type: Number,
      default: 0,
    },
    digitType: {
      type: Array,
      required: true,
    },
    lottoNumbersWithType: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      // buttonItemClass: "btn w-100 text-monospace btn-outline-dark",
      dialog_message: "",
      dialog: false,
      delVal: "",
      digits: [],
      selected: "",
    };
  },
  computed: {},
  mounted() {},
  methods: {
    checkActive(keyValue, digitType) {
      const degitReadAble = this.convertString(keyValue, digitType);
      if (digitType.length == 2) {
        const index1 = this.lottoNumbersWithType.findIndex(
          (x) => x.digits == degitReadAble && x.type == digitType[0]
        );
        const index2 = this.lottoNumbersWithType.findIndex(
          (x) => x.digits == degitReadAble && x.type == digitType[1]
        );
        if (index1 != -1 && index2 != -1) {
          return true;
        }
        return false;
      }
      if (digitType.length == 1) {
        const index = this.lottoNumbersWithType.findIndex(
          (x) => x.digits == degitReadAble && x.type == digitType[0]
        );
        if (index != -1) {
          return true;
        }
        return false;
      }
    },
    pushDigit(evn) {
      const stringSearch = evn.target.className.search("active");

      if (stringSearch != -1) {
        this.$set(this, "dialog", true);
        this.$set(
          this,
          "dialog_message",
          `ต้องการลบเลข ${evn.currentTarget.innerText}`
        );
        this.$set(this, "delVal", evn.currentTarget.innerText);
      } else {
        this.$emit("child-digitClick", evn.currentTarget.innerText);
      }
    },
    convertString(val, type) {
      if (type.indexOf("any_upper") != -1 || type.indexOf("any_under") != -1) {
        return val.toString();
      }
      if (type.indexOf("2upper") != -1 || type.indexOf("2under") != -1) {
        if (val < 10) {
          return `0${val.toString()}`;
        }
        return val.toString();
      }
      if (type.indexOf("3front") != -1 || type.indexOf("3back") != -1) {
        if (val < 10) {
          return `00${val.toString()}`;
        }
        if (val >= 10 && val < 100) {
          return `0${val.toString()}`;
        }
        return val.toString();
      }
      if (val < 10) {
        return `00${val.toString()}`;
      }
      if (val >= 10 && val < 100) {
        return `0${val.toString()}`;
      }
      return val.toString();
    },
    specialButtonDel() {
      this.$emit("child-digitClick", this.delVal);
    },
  },
};
</script>
